import { SvgIcon, SvgIconProps } from '@mui/material';

const PolygonFilled = ({ fill, fillOpacity, sx, ...props }: SvgIconProps) => {
  return (
    <SvgIcon
      {...props}
      data-testid="PolygonFilledIcon"
      sx={{
        fill: fill,
        fillOpacity: fillOpacity ?? 1,
        ...sx
      }}
    >
      <path d="M18.9875 2.45215C19.4568 2.46621 19.8615 2.77583 20.0022 3.2168L20.0276 3.30665L22.4954 14.1025C22.6155 14.6281 22.3374 15.163 21.8381 15.3662L4.74047 22.3154C4.05648 22.5932 3.29889 22.1317 3.23168 21.3965L1.56469 3.16309C1.50482 2.50592 2.03302 1.94438 2.69262 1.96387L18.9875 2.45215Z" />
    </SvgIcon>
  );
};

export default PolygonFilled;
